import React from 'react';
import PropTypes from 'prop-types';

import {
  Title,
  Description,
  ActionsContainer,
  RoundedModal,
  ModalContentWrapper,
  HeaderContainer,
  BodyContainer,
} from './styles';

const Modal = ({
  open,
  onClose,
  children,
  title,
  description,
  actionButtons,
  noPadding,
  className,
  ...otherProps
}) => (
  <RoundedModal
    open={open}
    onClose={onClose}
    {...otherProps}
  >
    <ModalContentWrapper className={className}>
      <HeaderContainer>
        <Title>{title}</Title>
        {!!description && <Description>{description}</Description>}
      </HeaderContainer>
      <BodyContainer $noPadding={noPadding}>
        {children}
      </BodyContainer>
      {!!actionButtons && (
        <ActionsContainer>
          {actionButtons}
        </ActionsContainer>
      )}
    </ModalContentWrapper>
  </RoundedModal>
);

Modal.propTypes = {
  children: PropTypes.any.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  actionButtons: PropTypes.element,
  description: PropTypes.string,
  noPadding: PropTypes.bool,
  className: PropTypes.string,
};
Modal.defaultProps = {
  description: '',
  actionButtons: null,
  noPadding: false,
  className: '',
};
export default Modal;
